import { TbCircleCheck } from "react-icons/tb";
import styled from "styled-components";
import { AccordionStateEnum } from "./Accordion";
import { devices } from "../../ExternFormEnrollment.styles";

const getBackgroundColor = (state: AccordionStateEnum) => {
  switch (state) {
    case AccordionStateEnum.Completed:
      return `
            background-color: #f3fafa;
            `;
    case AccordionStateEnum.Active:
      return `
            background-color: #fff;
            `;
    case AccordionStateEnum.Inactive:
      return `
            background-color: #fff;
            `;
  }
};

export const Wrapper = styled.div<{ state: AccordionStateEnum; }>`
  scroll-margin-top: 800px;
  box-shadow: 0px 0px 10px 2px rgba(1, 61, 68, 0.1);
  border-radius: 12px;
  margin-bottom: 8px;
  ${({ state }) => getBackgroundColor(state)}
`;

export const Header = styled.div<{ state: AccordionStateEnum; clickable?: boolean }>`
  padding: 20px;
  @media ${devices.tablet} {
    padding: 22px 26px;
  }
  @media ${devices.laptop} {
    padding: 23px 30px;
  }
  width: 100%;
  text-transform: initial;
  font-weight: ${({ state }) => (state === "Active" ? "600" : "normal")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
`;

export const DivInHeader = styled.div`
  display: flex;
`;

export const HeaderIcon = styled.img`
  margin-right: 8px;
  width: 22px;
  display: inline;
`;

export const Title = styled.p<{ state: AccordionStateEnum }>`
  display: inline;
  margin-bottom: 0px;
  font-weight: ${({ state }) => (state === "Active" ? "600" : "normal")};
`;

export const Content = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;
  overflow: hidden;
  transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const ContentInner = styled.div<{ height?: number }>`
  padding: 0px 20px 20px 20px;
  opacity: ${({ height }) => (height ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  @media ${devices.tablet} {
    padding: 0px 26px 26px 26px;
  }
  @media ${devices.laptop} {
    padding: 0px 30px 30px 30px;
  }
`;

export const CompletedIcon = styled(TbCircleCheck)`
  color: #ffffff;
  fill: var(--color-blue-700);
  display: inline;
  float: right;
  height: 26px;
  width: 26px;
`;

export const Navigation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  @media ${devices.tablet} {
    width: 80%;
    flex-direction: row;
    gap: 24px;
  }
  @media ${devices.laptop} {
    width: 60%;
    gap: 40px;
  }
`;

export const CampaignImg = styled.img`
  height: auto;
  max-width: 100%;
  margin-bottom: -4px;
`;

export const BackButtonContainer = styled.div`
  order: 2;
  @media ${devices.laptop} {
    order: 0
  } 
`;

export const ProgressWrapper = styled.div`
  width: 100%;
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  margin-top: 24px;
`;

export const Progress = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid var(--color-blue-700);
  background-color: var(--color-blue-50);
`;

export const ProgressFull = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid var(--color-blue-700);
  background-color: var(--color-blue-700);
`;